var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":"","offset-y":""}},[_c('v-btn',_vm._g({attrs:{"slot":"activator","flat":"","icon":""},slot:"activator"},_vm.$listeners),[_c('img',{attrs:{"src":_vm.imgSrc,"height":_vm.height}})]),_c('span',[_vm._v(_vm._s(_vm.tooltip))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }